/** PIN TO WALL — restrained action for canonical Archive objects. */
import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Pin, PinOff } from "lucide-react";
import { useMemberAuth } from "../hooks/useMemberAuth";
import { createPin, checkPinned, deletePin } from "./api";

export const PinToWallButton = ({ type, refId, className = "" }) => {
  const { member } = useMemberAuth();
  const [state, setState] = useState({ pinned: false, pinId: null });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!member || !refId) return;
    checkPinned(type, refId).then((r) => setState({ pinned: r.pinned, pinId: r.pin_id })).catch(() => {});
  }, [member, type, refId]);

  if (!member) return null;

  const toggle = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (state.pinned && state.pinId) {
        await deletePin(state.pinId);
        setState({ pinned: false, pinId: null });
        toast.success("Removed from your Wall");
      } else {
        const r = await createPin(type, refId);
        setState({ pinned: true, pinId: r.pin_id });
        toast.success(r.already_pinned ? "Already on your Wall" : "Pinned to your Wall");
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Pin failed");
    } finally { setBusy(false); }
  };

  return (
    <button onClick={toggle} disabled={busy} data-testid={`pin-to-wall-${type}-${refId}`}
      title={state.pinned ? "On your Wall" : "Pin to Wall"}
      className={`inline-flex items-center gap-1.5 font-mono text-[9px] uppercase tracking-[0.25em] px-2.5 py-1.5 border transition-colors ${className}`}
      style={{ borderColor: state.pinned ? "#E0A526" : "#454038",
               color: state.pinned ? "#E0A526" : "#A39E93" }}>
      {state.pinned ? <PinOff size={10} /> : <Pin size={10} />}
      {state.pinned ? "On Wall" : "Pin to Wall"}
    </button>
  );
};

export default PinToWallButton;
